import ModuleTemplateList from "./components/List"
import ModuleTemplateForm from "./components/Form"
import ModuleTemplateView from "./components/View"

let module = "moduletemplates"

export default [
  { path: "moduletemplates", component: ModuleTemplateList, meta: { module: module, permissions: ["moduletemplate-access"] } },
  {
    path: "moduletemplates/create",
    component: ModuleTemplateForm,
    props: true,
    meta: { module: module, permissions: ["moduletemplate-create"] }
  },
  {
    path: "moduletemplates/edit/:id",
    component: ModuleTemplateForm,
    props: true,
    meta: { module: module, permissions: ["moduletemplate-edit"] }
  },
  {
    path: "moduletemplates/view/:id",
    component: ModuleTemplateView,
    props: true,
    meta: { module: module, permissions: ["moduletemplate-access"] }
  }
]
